import React from "react";
import { Modal, Row, Col } from "antd";

class ModalUpdate extends React.Component {
  render() {
    let { status } = this.props;
    return (
      <Modal
        title="Konfirmasi"
        visible={this.props.modalUpdate}
        onOk={() =>
          this.setState({ modalUpdate: false }, () => this.props.updateBanner())
        }
        onCancel={() => this.props.closeModal()}
        okText="Submit"
        width={400}>
        Apakah anda yakin untuk{" "}
        {status === "Active" ? "Mengaktifkan" : "Menghapus"} banner ini?
      </Modal>
    );
  }
}

export default ModalUpdate;



// WEBPACK FOOTER //
// src/components/Dashboard/BannerList/ModalUpdate.js